import { format as formatter, isValid, parse } from 'date-fns';
import { nl } from 'date-fns/locale';
export const USER_DATE_FORMAT = 'dd-MM-yyyy';
export const USER_SHORT_DATE_FORMAT = 'ddMMyyyy';
export const USER_SHORT_DATE_WITH_SPACES_FORMAT = 'dd MM yyyy';
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';
export const ERROR_DATE_FORMAT = 'd MMMM yyyy';
export const DISPLAY_DATE_FORMAT = 'dd MMM yyyy';
export const getDateStringFromProp = (value) => {
    if (value === undefined) {
        return undefined;
    }
    if (typeof value === 'number') {
        const date = new Date(value);
        return formatDate(date, ISO_DATE_FORMAT);
    }
    return value;
};
export const normalizeDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
export const formatDate = (date, format) => {
    return formatter(date, format, { locale: nl });
};
export const parseDate = (date, format) => {
    return parse(date, format, new Date(), { locale: nl });
};
export const tryParseDate = (dateString, formats) => {
    for (let i = 0; i < formats.length; i += 1) {
        const format = formats[i];
        const date = safeParseDate(dateString, format);
        if (date !== undefined) {
            return date;
        }
    }
    return undefined;
};
export const isValidDateString = (value, format) => {
    if (value.trim() === '') {
        return false;
    }
    const date = parse(value, format, new Date(), { locale: nl });
    return isValid(date);
};
/**
 * Generate an array of years within a range.
 */
export const generateYears = ({ from, to }) => {
    if (to.getFullYear() <= from.getFullYear()) {
        return [to.getFullYear()];
    }
    return Array.from({ length: to.getFullYear() - from.getFullYear() + 1 }, (_, index) => from.getFullYear() + index);
};
/**
 * Add years to a date.
 */
export const addYears = (date, years) => {
    const newDate = new Date(date);
    newDate.setFullYear(date.getFullYear() + years);
    return newDate;
};
/**
 * Get an array of years within a range.
 */
export const getYears = ({ from, to }) => {
    const today = new Date();
    const range = {
        from: from !== null && from !== void 0 ? from : addYears(today, -100),
        to: to !== null && to !== void 0 ? to : addYears(today, 10),
    };
    return generateYears(range);
};
/**
 * Get the months of the year in the correct locale.
 */
export const getMonths = () => {
    return Array.from({ length: 12 }, (_, i) => {
        const date = new Date();
        // Set to the first day of the month, otherwise on the 31st of a month it will go to the next month.
        date.setDate(1);
        date.setMonth(i);
        return formatDate(date, 'MMMM');
    });
};
/**
 * This function is a wrapper around date-fns parse function. It will parse the date string with the provided format
 * with the parse function from date-fns. The result will be checked if it is a valid Date. It converts a string to
 * a valid Date object.
 */
export function safeParseDate(value, format) {
    if (value === undefined) {
        return undefined;
    }
    const date = parseDate(value, format);
    if (isValid(date)) {
        return date;
    }
    return undefined;
}
//# sourceMappingURL=date.js.map